import React from 'react';

export const SearchIcon = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.436 15.085L20.376 19.095C20.5525 19.2858 20.6478 19.5378 20.6417 19.7976C20.6356 20.0574 20.5286 20.3047 20.3433 20.4869C20.158 20.6692 19.9091 20.7722 19.6492 20.7741C19.3893 20.776 19.1389 20.6766 18.951 20.497L15.013 16.491C13.4935 17.6356 11.5959 18.1601 9.70428 17.9582C7.81266 17.7563 6.06845 16.8431 4.82482 15.4036C3.58118 13.964 2.93106 12.1057 3.00608 10.2048C3.08111 8.30391 3.87568 6.50257 5.22891 5.16551C6.58214 3.82845 8.3929 3.05558 10.2945 3.0034C12.1962 2.95123 14.0466 3.62364 15.4711 4.88448C16.8956 6.14533 17.7878 7.90039 17.9669 9.79429C18.1461 11.6882 17.5988 13.5794 16.436 15.085ZM10.5 16C11.9587 16 13.3576 15.4205 14.3891 14.3891C15.4205 13.3576 16 11.9587 16 10.5C16 9.04131 15.4205 7.64236 14.3891 6.61091C13.3576 5.57946 11.9587 5 10.5 5C9.04131 5 7.64236 5.57946 6.61091 6.61091C5.57946 7.64236 5 9.04131 5 10.5C5 11.9587 5.57946 13.3576 6.61091 14.3891C7.64236 15.4205 9.04131 16 10.5 16Z"
      fill={color || '#42526E'}
    />
  </svg>
);
